const WalletState = {
    transactionPinStatus: {},
    walletPolicies: [],
    walletRequests: {
        data: []
    }
};

export default WalletState;